import { Download, Ruler } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API_URL } from "@/api/client";

/**
 * Odrezky pri píle (KOLO 179) — program pre PC pri píle na stiahnutie.
 *
 * KOLO 182: user chce, aby program *„čo najmenej zasahoval do toho PC na
 * píle"* — kompiluje sa na kancelárskom PC a na pílu sa priečinok len
 * skopíruje; štart s PC je odkaz v priečinku Po spustení.
 *
 * User: *„aby operátor píly vedel sám zadať odrezky k zákazke … daj do
 * .exe čo najmenej, všetku logiku nechaj v Rozpočte"*. Program len ukáže
 * formulár a vety z Rozpočtu; inštalátor ho na PC skompiluje (v zipe nie
 * je `.exe`) a opýta sa na kľúč. Kľúč patrí samostatnému používateľovi
 * Píla — nový kľúč by inak zrušil ten, s ktorým posiela pomocník.
 */
export const PILA_ZIP = `${API_URL}/pila/program.zip`;

export function PilaOdrezkySection(): JSX.Element {
  return (
    <section className="space-y-3 rounded-lg border bg-card p-4" aria-labelledby="pila-odrezky-nadpis">
      <div>
        <h2 id="pila-odrezky-nadpis" className="flex items-center gap-2 text-xl">
          <Ruler className="h-5 w-5 text-primary" />
          Odrezky pri píle
        </h2>
        <p className="text-xs text-muted-foreground">
          Operátor pri píle vyberie zákazku, ktorá je na píle, popridáva odrezky
          (aj upraví či zmaže tie z kancelárie) a raz odošle. Rozpočet zákazku pošle
          do Cut Rite a nový plán <strong>sám pošle na pílu</strong> — bez tlačidla
          Odoslať na pílu; keď sa nový odrezok nepoužil, plán sa nemení a na pílu
          nejde. Tlačidlo Nárezový plán ukáže plán, ktorý je na píle. Krížik program
          nevypne, len zmenší. Texty a pravidlá sú v Rozpočte, program pri píle sa pri
          zmenách nemení.
        </p>
      </div>

      <ol className="list-decimal space-y-1 pl-5 text-sm">
        <li>
          V <strong>Správa → Používatelia</strong> vytvor používateľa <strong>Píla</strong>{" "}
          (nie admin).
        </li>
        <li>
          V súkromnom okne prehliadača sa prihlás ako Píla a tu v Prepojeniach vytvor{" "}
          <strong>Môj kľúč</strong>. Svoj kľúč nepoužívaj — nový by zrušil ten, ktorým
          posiela pomocník pre Cut Rite.
        </li>
        <li>
          Stiahni program, na <strong>svojom</strong> PC ho rozbaľ a dvojklikom spusti{" "}
          <span className="font-mono">instaluj.bat</span>. Keď sa opýta, vlož kľúč Píly.
          Program bude v <span className="font-mono">C:\TandemOdrezky</span>.
        </li>
        <li>
          Na PC pri píle nič neinštaluj — skopíruj tam celý priečinok{" "}
          <span className="font-mono">C:\TandemOdrezky</span> a odkaz{" "}
          <span className="font-mono">Odrezky.lnk</span> z neho na plochu.
        </li>
        <li>
          Aby sa spúšťal so zapnutím PC: <span className="font-mono">Win + R</span> →{" "}
          <span className="font-mono">shell:startup</span> → vlož tam ten istý odkaz.
          Program počká na internet a druhé spustenie len ukáže otvorené okno.
        </li>
        <li>
          Nová verzia: na pílu skopíruj len <span className="font-mono">Odrezky.exe</span>.
          Bežiaci program najprv ukonči — krížik ho nevypne:{" "}
          <span className="font-mono">Ctrl + Shift + Esc</span> → Odrezky → Ukončiť úlohu.
        </li>
      </ol>

      <Button asChild size="sm">
        <a href={PILA_ZIP} download>
          <Download className="h-4 w-4" />
          Stiahnuť program pre pílu
        </a>
      </Button>
    </section>
  );
}
